import React from 'react'
import axios from "axios";

export default class Anxios extends React.Component {
    headers: object;
    payload: object;

    constructor(props: any) {
        super(props);
        this.headers = {
            'Content-Type': 'application/json',
            'request-date': new Date().toUTCString(),
            'Accept-Language': 'EN',
        };
        this.payload = {}
    }

    async post(url: string, params: any) {

        this.payload = params;

        return axios.post(url, params, {
            headers: this.headers,
        });
    }

    async get(url: string, params: any) {

        this.payload = params;

        return axios.get(url, {
            headers: this.headers,
            params
        });
    }

}
